import React from 'react';
import bem from 'utils/bem';
import MenuLink from './MenuLink';

import './index.sass';

const { cnBlock, el } = bem('menu');

const Menu = ({ data, className, mods }) => (
    <div className={cnBlock(className, mods)}>
        {data.map(item => <MenuLink key={item.id} className={el('item')} {...item} />)}
    </div>
);

export default Menu;
